<template>
  <div>
    <div class="btn-wrapper mb-10 move-right">
      <button @click="$router.go(-1)" class="btn-back">
        <span>Back</span>
      </button>
    </div>
    <div class="white-bg">
      <h3 class="bold mb-20">Reports</h3>
      <el-tabs :tab-position="tabPosition" v-model="activeName">
        <el-tab-pane label="Simple">
          <ReportForm
            titleText="Simple"
            report_type="simple"
            @generateReport="generateReport"
          />
        </el-tab-pane>
        <el-tab-pane label="Lateness">
          <ReportForm
            titleText="Lateness"
            report_type="lateness"
            @generateReport="generateReport"
          />
        </el-tab-pane>
        <el-tab-pane label="Early In">
          <ReportForm
            titleText="Early In"
            report_type="earlyIn"
            @generateReport="generateReport"
        /></el-tab-pane>
        <el-tab-pane label="Workforce">
          <ReportForm
            titleText="Workforce"
            report_type="workforce"
            @generateReport="generateReport"
          />
        </el-tab-pane>
        <el-tab-pane label="Absentee">
          <ReportForm
            titleText="Absentee"
            report_type="absentee"
            @generateReport="generateReport"
          />
        </el-tab-pane>
        <el-tab-pane label="Log">
          <ReportForm
            titleText="Log"
            report_type="logs"
            @generateReport="generateReport"
          />
        </el-tab-pane>
        <el-tab-pane label="Punctuality">
          <ReportForm
            titleText="Punctuality"
            report_type="punctuality"
            @generateReport="generateReport"
          />
        </el-tab-pane>
        <el-tab-pane label="Attendance Summary">
          <ReportForm
            titleText="Summary"
            report_type="summary"
            @generateReport="generateReport"
        /></el-tab-pane>
        <el-tab-pane label="Off Day">
          <ReportForm
            titleText="Off Day"
            report_type="offday"
            @generateReport="generateReport"
        /></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ReportForm from "../components/ReportForm";

export default {
  components: {
    ReportForm,
  },

  data() {
    return {
      tabPosition: "left",
      activeName: 0,
    };
  },

  mounted() {
    this.activeName = this.$store.state.admin.attendance.reports.activeName;
  },

  methods: {
    generateReport(reportParams) {
      this.$store.commit("admin/attendance/reports/reportParams", reportParams);
      this.$store.commit(
        "admin/attendance/reports/activeName",
        this.activeName
      );
      this.$router.push({
        name: "view-ess-attendance-reports",
        params: { reportParams },
      });
    },
  },
};
</script>
